import { render, staticRenderFns } from "./TaskWasAssigned.vue?vue&type=template&id=70ef0c28"
import script from "./TaskWasAssigned.vue?vue&type=script&lang=js"
export * from "./TaskWasAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports